
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $e0d9b80646a02a3f$exports = {};

$parcel$export($e0d9b80646a02a3f$exports, "spectrum-ColorControl-handle--focused", function () { return $e0d9b80646a02a3f$export$1dd67f16e0d58f73; }, function (v) { return $e0d9b80646a02a3f$export$1dd67f16e0d58f73 = v; });
$parcel$export($e0d9b80646a02a3f$exports, "focus-ring", function () { return $e0d9b80646a02a3f$export$f39a09f249340e2a; }, function (v) { return $e0d9b80646a02a3f$export$f39a09f249340e2a = v; });
$parcel$export($e0d9b80646a02a3f$exports, "is-disabled", function () { return $e0d9b80646a02a3f$export$d35bc1e505d1ebbf; }, function (v) { return $e0d9b80646a02a3f$export$d35bc1e505d1ebbf = v; });
$parcel$export($e0d9b80646a02a3f$exports, "is-focused", function () { return $e0d9b80646a02a3f$export$e7dc768d35940237; }, function (v) { return $e0d9b80646a02a3f$export$e7dc768d35940237 = v; });
$parcel$export($e0d9b80646a02a3f$exports, "spectrum-ColorHandle", function () { return $e0d9b80646a02a3f$export$cd9afaa621b6216f; }, function (v) { return $e0d9b80646a02a3f$export$cd9afaa621b6216f = v; });
$parcel$export($e0d9b80646a02a3f$exports, "spectrum-ColorHandle-color", function () { return $e0d9b80646a02a3f$export$afe4c366ed4e659c; }, function (v) { return $e0d9b80646a02a3f$export$afe4c366ed4e659c = v; });
var $e0d9b80646a02a3f$export$1dd67f16e0d58f73;
var $e0d9b80646a02a3f$export$f39a09f249340e2a;
var $e0d9b80646a02a3f$export$d35bc1e505d1ebbf;
var $e0d9b80646a02a3f$export$e7dc768d35940237;
var $e0d9b80646a02a3f$export$cd9afaa621b6216f;
var $e0d9b80646a02a3f$export$afe4c366ed4e659c;
$e0d9b80646a02a3f$export$1dd67f16e0d58f73 = `myBuwa_spectrum-ColorControl-handle--focused`;
$e0d9b80646a02a3f$export$f39a09f249340e2a = `myBuwa_focus-ring ${$e0d9b80646a02a3f$export$1dd67f16e0d58f73}`;
$e0d9b80646a02a3f$export$d35bc1e505d1ebbf = `myBuwa_is-disabled`;
$e0d9b80646a02a3f$export$e7dc768d35940237 = `myBuwa_is-focused ${$e0d9b80646a02a3f$export$1dd67f16e0d58f73}`;
$e0d9b80646a02a3f$export$cd9afaa621b6216f = `myBuwa_spectrum-ColorHandle`;
$e0d9b80646a02a3f$export$afe4c366ed4e659c = `myBuwa_spectrum-ColorHandle-color`;


export {$e0d9b80646a02a3f$exports as default};
//# sourceMappingURL=colorhandle_vars_css.mjs.map
